export function b64EncodeUnicode( str ) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  // [WindowOrWorkerGlobalScope.btoa()](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa)
  return btoa( encodeURIComponent( str ).replace( /%([0-9A-F]{2})/g,
    function toSolidBytes( match, p1 ) {
      return String.fromCharCode( '0x' + p1 );
    } ) );
}